module.exports = __webpack_public_path__ + "static/media/gatech 1.dd69c046.png";